<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <navmenu :menuMobile="false"></navmenu>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-5 col-lg-6 col-md-8 col-sm-9 col-12 forms">
          <form action="">
            <div class="text-center custom-col">
              <h1 class="title-view-2 mb-1">Recover Password</h1>
              <div class="textInHorizontalLine">
                <span>Internal</span>
              </div>
            </div>
            <div class="card pb-3 mt-4 mb-2">
              <form>
                <div class="card-body">
                  <input hidden type="text" autocomplete="username" value="" />
                  <span class="d-block f2 text-center mb-4"
                    >Enter a new password to recover your account</span
                  >
                  <div class="col-12">
                    <base-input
                      label="Password"
                      class="input-append"
                      placeholder="Password"
                      v-model="data.password"
                      autocomplete="new-password"
                      :type="typePassword"
                      :successMessage="'Strong Password'"
                      :valid="$v.data.password.strongPassword"
                      :tooltip="true"
                      titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                      contentTooltip='<ul class="ul-pop">
                                  <li>Minimum 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                      :error="
                        validatePassword(
                          $v.data.password.minLength,
                          $v.data.password.$error,
                          $v.data.password.$params,
                          $v.data.password.$model,
                          $v.data.password.required
                        )
                      "
                      indexTab="1"
                      :focusact="true"
                      markrequired
                      ><template slot="append">
                        <span @click="seePassword()" class="icon-button"
                          ><i
                            v-bind:class="{
                              'flaticon-view-1': typePassword == 'password',
                              'flaticon-hidden': typePassword == 'text'
                            }"
                          ></i
                        ></span> </template
                    ></base-input>
                  </div>
                  <div class="col-12">
                    <base-input
                      label="Password Confirmation"
                      placeholder="Password Confirmation"
                      v-model="data.repeatPassword"
                      type="password"
                      indexTab="2"
                      markrequired
                      autocomplete="new-password"
                      :error="
                        !$v.data.repeatPassword.sameAsPassword ||
                        $v.data.repeatPassword.$error
                          ? `Passwords must be identical.`
                          : ''
                      "
                    ></base-input>

                    <div class="text-center">
                      <base-button
                        type="primary"
                        class="min-button"
                        @click="savePassword()"
                        tabindex="3"
                        >Accept</base-button
                      >
                    </div>
                  </div>

                  <div class="loading mt-3" v-if="load">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-12 alinmov5">
              <router-link to="/signin" class="link" tabindex="4"
                >Sign In
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <layoutFooter class="footer-pages"></layoutFooter>
  </div>
</template>
<script>
import Navbarpages from "@/layouts/Navbarpages";
import Swal from "sweetalert2";
import layoutFooter from "@/layouts/ContentFooter";
import { AuthAPI } from "@/core/api";
import { minLength, sameAs } from "vuelidate/lib/validators";
export default {
  components: {
    navmenu: Navbarpages,
    layoutFooter: layoutFooter
  },
  data() {
    return {
      data: {
        password: "",
        repeatPassword: ""
      },
      load: false,
      type: "",
      token: "",
      userId: "",
      operation: "",
      typePassword: "password"
    };
  },
  async created() {
    this.userId = this.$route.query.userId ? this.$route.query.userId : null;
    this.userType = this.$route.query.userType
      ? this.$route.query.userType
      : null;
    this.operation = this.$route.query.operation
      ? this.$route.query.operation
      : null;
    this.token = this.$route.query.token ? this.$route.query.token : "";
  },
  methods: {
    async savePassword() {
      if (!this.$v.data.$invalid) {
        await this.restorePassword(this.data);
      } else {
        this.$v.data.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async restorePassword(user) {
      try {
        this.load = true;
        let { data } = await AuthAPI.restorePassword(
          this.userId,
          this.userType,
          user,
          this.operation,
          this.token
        );
        this.load = false;
        if (data.status) {
          let { value } = await Swal.fire({
            title: "Success",
            html: "You can now log in with your new password",
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/success.png"),
            buttonsStyling: false,
            focusConfirm: false,
            reverseButtons: true,
            confirmButtonText: "Accept",
            confirmButtonClass: "btn btn-primary btn-small-one"
          });
          if (value) {
            this.$router.push("/signin");
          }
          this.data.password = "";
          this.data.repeatPassword = "";
        } else {
          let { value } = await Swal.fire({
            title: "Error",
            html:
              'An error occurred while saved your changes,<br> try again or <a href="https://www.rhomtrip.com/contact" target="blank">Contact us</a>',
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/error.png"),
            buttonsStyling: false,
            focusConfirm: false,
            reverseButtons: true,
            confirmButtonText: "Accept",
            confirmButtonClass: "btn btn-primary btn-small-one"
          });
          if (value) {
            this.$router.push("/signin");
          }
        }
      } catch (error) {
        this.load = false;
        let { value } = await Swal.fire({
          title: "Error",
          html:
            'An error occurred while saved your changes,<br> try again or <a href="https://www.rhomtrip.com/contact" target="blank">Contact us</a>',
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/error.png"),
          buttonsStyling: false,
          focusConfirm: false,
          reverseButtons: true,
          confirmButtonText: "Accept",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.$router.push("/signin");
        }
      }
    },
    validatePassword($minLength, $error, $params, $model, $required) {
      if ($error) {
        if (!$minLength) {
          return `Minimum 8 Characters`;
        } else if ($required && $model.length < 1) {
          return `Enter a valid password`;
        } else {
          return "Invalid password";
        }
      } else {
        return "";
      }
    },
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    }
  },
  validations: {
    data: {
      password: {
        required: true,
        minLength: minLength(8),
        strongPassword(password) {
          return (
            /[a-z]/.test(password) && // checks for a-z
            /[A-Z]/.test(password) && // checks for A-Z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) && // checks for special char
            password.length >= 8
          );
        }
      },
      repeatPassword: {
        sameAsPassword: sameAs("password")
      }
    }
  }
};
</script>
